<template>
  <StoreLocatorConfigSection :title="$t('message.storeLocator.posts.title')">
    <div class="sl-posts">
      <i18n
        path="message.storeLocator.posts.description"
        tag="div"
        class="sl-posts__description"
      >
        <template v-slot:0>
          <router-link :to="{ name: 'posts-list' }">{{
            $t("message.storeLocator.posts.descriptionLink")
          }}</router-link>
        </template>
      </i18n>
    </div>
  </StoreLocatorConfigSection>
</template>

<script>
import StoreLocatorConfigSection from "@/components/StoreLocator/StoreLocatorConfigSection";

export default {
  name: "StoreLocatorConfigPosts",
  components: {
    StoreLocatorConfigSection
  }
};
</script>

<style lang="scss" scoped>
.sl-posts {
  margin-bottom: $spacing * 3;

  &__description {
    @include font-size(14px);
    line-height: 17px;
    font-weight: 500;
    color: rgba($dark-blue-3, 0.9);
  }
}
</style>
